import { render, staticRenderFns } from "./QuestionCreateModal.vue?vue&type=template&id=545e8afd&"
import script from "./QuestionCreateModal.vue?vue&type=script&lang=js&"
export * from "./QuestionCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports